import { useEffect, useState } from "react";
import { useApi } from "../../context/AppContext";
import { TestConsolePage } from "../TestConsolePage";
import { LivePanel } from "./LivePanel";

// Live & test for one cabinet (docs/tasks/35): the state chips from its health,
// refreshed every 5 s, the door and charging controls, and the Test Console with
// the live panes, the review's windows on them and the current basket.
export function LiveTest({ deviceId }) {
  const api = useApi();
  const [health, setHealth] = useState(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.getDeviceHealth(deviceId).then((h) => alive && setHealth(h)).catch(() => {});
    void load();
    const t = setInterval(load, 5000);
    return () => { alive = false; clearInterval(t); };
  }, [api, deviceId]);
  return (
    <div className="space-y-4">
      <LivePanel deviceId={deviceId} health={health} />
      <TestConsolePage key={deviceId} fixedDeviceId={deviceId} analysisMode={health?.report?.analysis_mode} />
    </div>
  );
}
